export function hasEmptyValue(obj:any, whitelistKeys: string[] = []) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      // Check if the value is an object and recursively check for emptiness
      if (typeof value === 'object' && value !== null) {
        if (hasEmptyValue(value, whitelistKeys)) {
          return true;
        }
      } else if (
        (value === '' || value === null || value === undefined) &&
        !whitelistKeys.includes(key)
      ) {
        return true; // Found an empty value
      }
    }
  }
  return false; // No empty values found
}
